import React from 'react';
import ContainerValidation from "../External/Components/ContainerValidation";
import QrRequestAccessMainApp from "./Functionality/QrRequestAccessMainApp";
import HeaderValidation from "../External/Components/HeaderValidation";
import BodyValidation from "../External/Components/BodyValidation";
import ChooseType from "../External/Components/ChooseType";
import {REQUEST_ACCESS_TYPE} from "./Model/Model";

/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const QrRequestAccessMain = () => {
    const { t, selectionType, setSelectionType, getUrl, title} = QrRequestAccessMainApp();

    return (
        <ContainerValidation>
            <HeaderValidation
                showBtnBack={false}
            />

            <BodyValidation
                click={() => { getUrl() }}
                btnDisabled={selectionType === null}
            >
                <>
                    <div className="row">
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                            <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center">{t(title)}</p>
                            <p className="fs-20-to-14 font-color-general-950 text-center mt-3">{t("please_choose_one_of_the_following_options")}</p>

                        </div>
                    </div>


                    <ChooseType
                        id={REQUEST_ACCESS_TYPE.FIND_EXISTING_PROFILE.ID}
                        title={REQUEST_ACCESS_TYPE.FIND_EXISTING_PROFILE.TITLE}
                        subtitle={REQUEST_ACCESS_TYPE.FIND_EXISTING_PROFILE.SUBTITLE}
                        Icon={REQUEST_ACCESS_TYPE.FIND_EXISTING_PROFILE.ICON}
                        name={REQUEST_ACCESS_TYPE.FIND_EXISTING_PROFILE.INDEX}
                        value={REQUEST_ACCESS_TYPE.FIND_EXISTING_PROFILE.INDEX}
                        checked={parseInt(selectionType) === REQUEST_ACCESS_TYPE.FIND_EXISTING_PROFILE.INDEX}
                        setSelectionType={setSelectionType}
                        iconClass={"h-24px"}
                    />

                    <ChooseType
                        id={REQUEST_ACCESS_TYPE.I_AM_NEW_HERE.ID}
                        title={REQUEST_ACCESS_TYPE.I_AM_NEW_HERE.TITLE}
                        subtitle={REQUEST_ACCESS_TYPE.I_AM_NEW_HERE.SUBTITLE}
                        Icon={REQUEST_ACCESS_TYPE.I_AM_NEW_HERE.ICON}
                        name={REQUEST_ACCESS_TYPE.I_AM_NEW_HERE.INDEX}
                        value={REQUEST_ACCESS_TYPE.I_AM_NEW_HERE.INDEX}
                        checked={ parseInt(selectionType) === REQUEST_ACCESS_TYPE.I_AM_NEW_HERE.INDEX}
                        setSelectionType={setSelectionType}
                        iconClass={"h-24px"}
                    />
                </>
            </BodyValidation>
        </ContainerValidation>
    )
}

export default QrRequestAccessMain
